//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"Adjustment",1,0],[0,"Experience",1,0],[0,"OutputExperience",1,0],[0,"OutputOvertravel",1,0],[0,"OutputPercentFeedback",1,0],[0,"OutputToolOffset",1,0],[0,"OutputWorkOffset",1,0],[0,"Overtravel",1,0],[0,"PercentFeedback",1,0],[0,"Print",1,0],[0,"ToolOffset",1,0],[0,"WorkOffset",1,0]],[],[]];
SPLM.CAM.ProbeControlParametersBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ProbeControlParametersBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ProbeControlParametersBuilder.PrintType = Object.freeze({
    "None" : "None", "Feature" : "Feature", "Component" : "Component"});

SPLM.CAM.ProbeControlParametersBuilder.AdjustmentTypes = Object.freeze({
    "None" : "None", "Xy" : "Xy", "Xyz" : "Xyz", "Contact" : "Contact"});

export default SPLM;